module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Splendour in the Grass","short_name":"starter","start_url":"/","display":"minimal-ui","background_color":"#fff","theme_color":"#fff","icon":"src/assets/images/favicon.png"},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-W76NMC"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
